export const dateHelper = {
    data() {
        return {
            now: 0,
        }
    },
    mounted() {
        this.updateNow();
        setInterval(this.updateNow.bind(this), 1000);
    },
    methods: {
        updateNow() {
            var currTime;
            if (this.$diamond) {
                if (Math.abs(this.$diamond._serverTimeOffset) > 3000) currTime = (new Date()).getTime() - this.$diamond._serverTimeOffset
                else currTime = (new Date()).getTime()
            } else {
                currTime = (new Date()).getTime()
            }
            this.now = currTime
        },
        toHMS(ms) {
            var secs = ms / 1000
            let d = Math.floor(secs/(24*3600)); 
            secs -= d*24*3600; 

            let h = Math.floor(secs/3600); 
            secs -= h*3600; 
             
            let m = Math.floor(secs/60); 
            secs -= m*60; 
            secs = Math.round(secs)
            return `${d != 0 ? `${d}d` : ` `} ${h != 0 || d != 0? `${this.padTo2(h)}h` : ` `} ${this.padTo2(m)}m ${this.padTo2(secs)}s`.trim()
        },
        toHHMMSS(ms){
            if(!ms)
            {
                return 'Not Available';
            }
            var secs = ms / 1000;
            let d = new Date(secs * 1000);
            let h = d.getUTCHours();
			let m = d.getUTCMinutes();
			let s = d.getSeconds();
		
			let timeString = h.toString().padStart(2, '0')
				+ ':' + m.toString().padStart(2, '0')
				+ ':' + s.toString().padStart(2, '0');
            return timeString;
        },
        padTo2(value) {
            if (!value) {
                return '00';
            }
            return value < 10 ? String(value).padStart(2, '0') : value;
        }
    }
}

export const arrayHelpers = {
    methods: {
        partition(array, isValid) {
            return array.reduce(
                ([pass, fail], elem) => {
                    return isValid(elem)
                        ? [[...pass, elem], fail]
                        : [pass, [...fail, elem]];
                },
                [[], []]
            );
        },
    }
}

export const objectHelpers = {
    methods: {
        getMissingKeys(a, b) {
            var aKeys = Object.keys(a).sort();
            var bKeys = Object.keys(b).sort();
            var missing = aKeys.filter(x => !bKeys.includes(x));
            return missing;
        },
    }
}

export const numHelpers = {
    methods: {
        isNumber(value) {
            return value === "Int32"
                || value === "Int64"
                || value === "Double"
                || value === "Long"
        },
        sum(items, prop) {
            if (!items) return 0
            return items.reduce(function (a, b) {
                return a + b[prop];
            }, 0);
        },
    }
}

export const strHelpers = {
    methods: {
        fieldCase(string) {
            return string[0].toLowerCase() + string.slice(1);
        },
        removeSpaces(string) {
            return string.replace(/\s/g, '');
        },
        capitaliseFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
}


export const resizer = {
    methods: {
        isOverflown({ clientHeight, scrollHeight, clientWidth, scrollWidth }) {
            return scrollHeight > clientHeight || scrollWidth > clientWidth;
        },

        hasOverflown({ elements, element }) {
            var els = [];
            (elements || [element]).forEach((el) => {
                if (this.isOverflown(el.parentNode)) els.push(el);
            })
            return els;
        },

        resizeText({
            element,
            elements,
            minSize = 10,
            maxSize = 512,
            step = 1,
            unit = "px",
        }) {
            (elements || [element]).forEach((el) => {
                let i = minSize;
                let overflow = false;
                const parent = el.parentNode;
                if (!parent) return;
                while (!overflow && i < maxSize) {
                    el.style.fontSize = `${i}${unit}`;
                    overflow = this.isOverflown(parent);

                    if (!overflow) i += step;
                }
                el.style.fontSize = `${i - step}${unit}`;
            });
        }
    }
}

